import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    marginTop: '8px',
    marginBottom: '8px',
  },
  icon: {
    color: '#44accd',
    marginRight: '8px',
  },
  label: {
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '24px',
  },
}));
